import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { getGraficosTipoAccidente } from '../api/informesApi'
import { TIPO_ACCIDENTE_CHART } from '../../../common/constants/charts'
import { createEmptyDonutChartResponse, mapDonutChartResponse } from '../utils/donutCharts'

export const useGraficosTipoAccidente = (trigger, reportData, contrato) => {
  const [data, setData] = useState(createEmptyDonutChartResponse())
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!trigger || !contrato || !reportData?.fechaDesde || !reportData?.fechaHasta) return

    const controller = new AbortController()

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await getGraficosTipoAccidente(contrato, reportData.fechaDesde, reportData.fechaHasta, {
          signal: controller.signal,
        })
        setData(mapDonutChartResponse(response.data, TIPO_ACCIDENTE_CHART))
      } catch (error) {
        if (error.name === 'CanceledError') return
        Sentry.captureException(error)
        setData(createEmptyDonutChartResponse())
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [trigger, contrato, reportData?.fechaDesde, reportData?.fechaHasta])

  return { data, isLoading, error }
}
